var _rect, _rect2, _rect3, _path, _circle, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentsSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 32,
    height: 40,
    rx: 6,
    fill: "#f8fafc",
    stroke: "#2563eb",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 20,
    width: 16,
    height: 4,
    rx: 2,
    fill: "#f59e0b"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 28,
    width: 12,
    height: 4,
    rx: 2,
    fill: "#60a5fa"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 40c0-2 2-4 4-4s4 2 4 4",
    stroke: "#2563eb",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 40,
    r: 2,
    fill: "#f59e0b"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 24,
    height: 6,
    rx: 3,
    fill: "#2563eb",
    fillOpacity: 0.12
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentsSupport);
export default __webpack_public_path__ + "static/media/documents-support.f05bfa7f944d36c7451e266dddf1109d.svg";
export { ForwardRef as ReactComponent };